/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import dayjs from "dayjs"
// other
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch } from "react-redux"
import { useHistory, useLocation, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { showInfoToast } from "../../../components/CustomToast"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import TextInput from "../../../components/InputWrapper/TextInput"
import LabelFormRow from "../../../components/LabelFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { 区分分類コード } from "../../../constant/enum/codes"
import { e休日区分 } from "../../../constant/enum/master"
import { e社員区分 } from "../../../constant/enum/syain"
import { e勤怠区分, 乗務員勤怠表示記号区分 } from "../../../constant/enum/unko"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import SyukkinboService from "../../../service/attendance/syukkinbo/syukkinboService"
import {
  TKintai,
  TSyukkinboDakokuGetRes,
  TSyukkinboGetReq,
  TZikanSyuseiListDetailPutReq,
  TZikanSyuseiListPutReq,
  TZyomuinSyukkinboDigitachoGetReq,
  TZyomuinSyukkinboDigitachoRes,
  TZyomuinSyukkinboSummaryGetRes,
} from "../../../service/attendance/syukkinbo/TSyukkinbo"
import KubunService from "../../../service/master/kubun/kubunService"
import KyuzituService from "../../../service/master/kyuzitu/kyuzituService"
import { TApiResponse } from "../../../service/TApiResponse"
import pageHelper from "../../../ts/helpers/pageHelper"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"

//#region [type]

export type T勤怠リスト = TKintai & {
  row_id: symbol
  複数行フラグ: number
}

//#endregion

/**
 * 出勤簿
 * @returns
 */
const ZyomuinSyukkinbo = () => {
  const history = useHistory()
  const location = useLocation()
  const { id: 所属_社員ID, date: 年月 } = useParams<{
    id: string
    date: string
  }>()
  const 勤怠記号DataMap = new wjcGrid.DataMap<{
    区分コード: string
    表示記号: string
  }>(乗務員勤怠表示記号区分, "区分コード", "表示記号")
  const 運行外勤怠記号DataMap = new wjcGrid.DataMap<{
    区分コード: string
    表示記号: string
  }>(
    乗務員勤怠表示記号区分.filter(
      (d) => d.表示記号 !== "有休" && d.表示記号 !== "特休"
    ),
    "区分コード",
    "表示記号"
  )
  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "ZyomuinSyukkinbo_GridId"
  let summaryCountGridId = "zyomuinSyukkinbo_SummaryCountGridId"
  let dakokuCountGridId = "zyomuinSyukkinbo_dakokuCountGridId"

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)
  //#region [method]

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TSyukkinboGetReq => {
    return {
      社員ID: parseInt(所属_社員ID),
      年月,
    }
  }
  /**
   * 検索条件オブジェクトを生成
   */
  const createDigitachoSearchCondition =
    (): TZyomuinSyukkinboDigitachoGetReq => {
      return {
        社員ID: parseInt(所属_社員ID),
        出庫日: dayjs(年月).startOf("month").format("YYYY/MM/DD"),
      }
    }
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<TKintai>) => {
    const bindItems: T勤怠リスト[] = data.map((item) => {
      return {
        ...item,
        row_id: Symbol(),
        複数行フラグ: 0,
      }
    })
    bindItems.forEach((d) => {
      if (bindItems.filter((f) => f.勤務日 === d.勤務日).length > 1) {
        d.複数行フラグ = 1
      }
    })
    return new wjCore.CollectionView(bindItems, {
      calculatedFields: {
        曜日: (i: T勤怠リスト) => {
          return dayjs(i.勤務日).format("ddd")
        },
        勤怠情報_表示勤怠区分: (i: T勤怠リスト) => {
          if (!勤怠区分ItemSource) return ""
          // 区分マスタの分類コード、社員区分でfilterする。
          // 勤怠区分と区分コードを比較するとuniqueになるので名称を取得する。
          const tmp = 勤怠区分ItemSource
            ?.filter((d) => d.分類コード === "U0002")
            .filter((m) => m.数値1 === parseInt(社員区分!) || m.数値1 === 0)
            .filter((k) => k.区分コード === i.勤怠区分コード)
          try {
            if (tmp) {
              const item = tmp[0].名称2
              return item
            }
          } catch (error) {
            return ""
          }
        },
        有休: (i: T勤怠リスト) => {
          const yukyu =
            i.勤怠区分コード === e勤怠区分.有給休暇 ? "〇" : undefined
          return yukyu
        },
        特休: (i: T勤怠リスト) => {
          const tokkyu =
            i.勤怠区分コード === e勤怠区分.特別休暇 ? "〇" : undefined
          return tokkyu
        },
        休日出勤: (i: T勤怠リスト) => {
          const kyusyutu = i.日曜フラグ === 1 ? i.勤務記号区分コード : undefined
          return kyusyutu
        },
        祝日出勤: (i: T勤怠リスト) => {
          const syukusyutu =
            i.日曜フラグ === 0 && i.祝日フラグ === 1
              ? i.勤務記号区分コード
              : undefined
          return syukusyutu
        },
      },
    })
  }
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createDigiTachoCollectionView = (
    data: Array<TZyomuinSyukkinboDigitachoRes>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createSummaryCollectionView = (
    data: TZyomuinSyukkinboSummaryGetRes[]
  ) => {
    return new wjCore.CollectionView(data, {
      calculatedFields: {
        有休残数: (i: TZyomuinSyukkinboSummaryGetRes) => {
          return i.年度開始有休日数 - i.有休取得数 > 0
            ? i.年度開始有休日数 - i.有休取得数
            : 0
        },
      },
    })
  }

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createDakokuCollectionView = (data: TSyukkinboDakokuGetRes[]) => {
    return new wjCore.CollectionView(data, {
      sortDescriptions: ["勤務日"],
      groupDescriptions: [
        new wjCore.PropertyGroupDescription(
          "勤務日",
          (i: TSyukkinboDakokuGetRes, property) => {
            return dayjs(i.勤務日).format("MM/DD")
          }
        ),
      ],
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition: TSyukkinboGetReq) => {
    const syukkinboService = new SyukkinboService()
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TSyukkinboGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成parse
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    try {
      const res = await syukkinboService.zyomuinGetIndividualList(
        currentSearchCondition
      )

      // 検索結果をstateにセット
      set部所コード(res.data.部所コード)
      set部所名(res.data.部所名)
      set社員番号(res.data.社員コード)
      set氏名(res.data.社員氏名)
      set社員区分(res.data.社員区分コード)
      // TimeSpanの返却値をdayjsに合わせるため加工
      let res勤怠リスト: TKintai[] = res.data.勤怠リスト
      const 勤怠リストitems: TKintai[] = []
      res勤怠リスト.forEach((d) => {
        const 勤怠リストitem: TKintai = {
          日別勤怠ID: d.日別勤怠ID,
          勤務日: d.勤務日,
          勤怠区分コード: d.勤怠区分コード,
          勤務記号区分コード: d.勤務記号区分コード,
          勤務記号区分名称1: d.勤務記号区分名称1,
          深夜記号区分コード: d.深夜記号区分コード,
          深夜記号区分名称1: d.深夜記号区分名称1,
          運行外業務記号区分コード: d.運行外業務記号区分コード,
          // 返却値がミリ秒のため、日付型に変換してからHH:mmの形に修正
          出勤時刻: d.出勤時刻
            ? dayjs(dayjs(d.勤務日).add(parseInt(d.出勤時刻), "ms")).format(
                "HH:mm"
              )
            : "",
          退勤時刻: d.退勤時刻
            ? dayjs(dayjs(d.勤務日).add(parseInt(d.退勤時刻), "ms")).format(
                "HH:mm"
              )
            : "",

          日曜フラグ: d.日曜フラグ,
          祝日フラグ: d.祝日フラグ,
          備考: d.備考,
          更新日時: d.更新日時,
        }
        勤怠リストitems.push(勤怠リストitem)
      })

      setGridData({ data: createCollectionView(勤怠リストitems) })

      const kyuzituRes = await new KyuzituService().getList({
        検索年: currentSearchCondition.年月,
      })
      kyuzituRes.data
        .filter(
          (d) =>
            d.休日区分コード === e休日区分.祝日 ||
            d.休日区分コード === e休日区分.会社休日
        )
        .forEach((i) => {
          holidayList.push({
            休日: i.休日日付,
          })
        })

      // 集計データ取得
      const summaryResList: TZyomuinSyukkinboSummaryGetRes[] = []
      const summaryRes = await syukkinboService.zyomuinGetSummaryList(
        currentSearchCondition
      )
      summaryResList.push(summaryRes.data)
      setSummaryGridData({ data: createSummaryCollectionView(summaryResList) })

      // 打刻データ取得
      const dakokuRes = await syukkinboService.getDakokuList(
        currentSearchCondition
      )
      const dakokuData: TSyukkinboDakokuGetRes[] = []
      dakokuRes.data.forEach((d) => {
        const 打刻リストitem: TSyukkinboDakokuGetRes = {
          勤怠打刻ID: d.勤怠打刻ID,
          社員ID: d.社員ID,
          勤務日: dayjs(d.勤務日).format("MM/DD"),
          出退勤区分ID: d.出退勤区分ID,
          出退勤区分コード: d.出退勤区分コード,
          出退勤区分名称1: d.出退勤区分名称1,
          出勤時間: d.出勤時間
            ? dayjs(dayjs(d.勤務日).add(parseInt(d.出勤時間), "ms")).format(
                "HH:mm"
              )
            : "",
          退勤時間: d.退勤時間
            ? dayjs(dayjs(d.勤務日).add(parseInt(d.退勤時間), "ms")).format(
                "HH:mm"
              )
            : "",
          出退勤時刻: d.出退勤時刻,
          削除フラグ: d.削除フラグ,
          作成日時: d.作成日時,
        }
        dakokuData.push(打刻リストitem)
      })
      setDakokuGridData({ data: createDakokuCollectionView(dakokuData) })

      // デジタコデータ取得

      try {
        const digiTachoRes = await new SyukkinboService().getDigiTachoList(
          createDigitachoSearchCondition()
        )
        const digiTachoData: TZyomuinSyukkinboDigitachoRes[] = []
        digiTachoRes.data.forEach((d) => {
          const digiTacho: TZyomuinSyukkinboDigitachoRes = {
            デジタコデータID: d.デジタコデータID,
            取込ファイルID: d.取込ファイルID,
            データ日付: d.データ日付,
            社員ID: d.社員ID,
            車番: d.車番,
            走行距離: d.走行距離,
            運転評価: d.運転評価,
            出庫日: d.出庫日,
            str出庫時刻: d.出庫時刻
              ? dayjs(dayjs(d.出庫日).add(d.出庫時刻, "ms")).format("HH:mm")
              : "",
            入庫日: d.入庫日,
            str入庫時刻: d.入庫時刻
              ? dayjs(dayjs(d.出庫日).add(d.入庫時刻, "ms")).format("HH:mm")
              : "",
            str稼働時間: d.稼働時間
              ? dayjs(dayjs(d.出庫日).add(d.稼働時間, "ms")).format("HH:mm")
              : "",
            str就業時間: d.就業時間
              ? dayjs(dayjs(d.出庫日).add(d.就業時間, "ms")).format("HH:mm")
              : "",
            str休憩時間: d.休憩時間
              ? dayjs(dayjs(d.出庫日).add(d.休憩時間, "ms")).format("HH:mm")
              : "",
            str休息時間: d.休息時間
              ? dayjs(dayjs(d.出庫日).add(d.休息時間, "ms")).format("HH:mm")
              : "",
            高速料: d.高速料,
          }
          digiTachoData.push(digiTacho)
        })

        // 検索結果をstateにセット
        setDigiTachoGridData({
          data: createDigiTachoCollectionView(digiTachoData, pageSize),
        })
      } catch (error) {
        // dispatch(setAlerts(error))
        dispatch(setWarningAlerts(["エラー表示"]))
      } finally {
        setIsDigiTachoSearching(false) // 検索中状態に遷移
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索状態切り替え
    }
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    // 追加行のみ初期化時に設定
    var extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)
    // ヘッダの設定
    grid.formatItem.addHandler(formatItem)
    grid.beginningEdit.addHandler(beginningEdit)
    grid.cellEditEnding.addHandler(cellEditEnding)
    grid.cellEditEnded.addHandler(cellEditEnded)
    grid.pastingCell.addHandler(pastingCell)

    grid.refresh()
  }

  /**
   * セル編集開始時イベント
   * @param s
   * @param e
   * @returns
   */
  const beginningEdit = (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let col = s.columns[e.col]
    switch (col.binding as keyof T勤怠リスト) {
      case "出勤時刻":
      case "退勤時刻":
        if (s.getCellData(e.row, e.col, false)) {
          let 時間: string = s.getCellData(e.row, e.col, false)
          時間 = 時間.replaceAll(":", "")
          s.setCellData(e.row, e.col, 時間)
        }
        break
    }
  }

  /**
   * セル編集開始時イベント
   * @param s
   * @param e
   * @returns
   */
  const cellEditEnding = async (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellEditEndingEventArgs
  ) => {
    let col = s.columns[e.col]
    switch (col.binding as keyof T勤怠リスト) {
      case "出勤時刻":
      case "退勤時刻":
        if (s.activeEditor && s.activeEditor.value) {
          if (!IsTimeNumber(s.activeEditor.value)) {
            e.cancel = true
          }
          break
        }
    }
  }

  /**
   * セル編集完了時イベント
   */
  const cellEditEnded = (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let col = s.columns[e.col]
    switch (col.binding as keyof T勤怠リスト) {
      case "出勤時刻":
      case "退勤時刻":
        if (s.getCellData(e.row, e.col, false)) {
          let newValue: string = s.getCellData(e.row, e.col, false)
          s.setCellData(e.row, e.col, convTimeString(newValue))
        }
        break
    }
  }

  /**
   * ペーストイベント
   */
  const pastingCell = (s: wjcGrid.FlexGrid, e: wjcGrid.CellRangeEventArgs) => {
    const pastingData = e.data
    let col = s.columns[e.col]
    if (pastingData) {
      switch (col.binding as keyof T勤怠リスト) {
        case "出勤時刻":
        case "退勤時刻":
          if (!IsTimeNumber(pastingData)) {
            e.cancel = true
          }
          e.data = convTimeString(pastingData)
          break
      }
    }
  }

  /**
   * 時間文字列に変換
   * @param s:any
   * @return hhmm、hh:mmの場合はtrue、違う場合はfalse
   */
  const convTimeString = (s: any) => {
    let resultString = s.replaceAll(":", "")
    // 0埋め
    resultString = ("0000" + resultString).slice(-4)
    resultString = resultString.slice(0, 2) + ":" + resultString.slice(-2)
    return resultString
  }

  /**
   * 時間を示す数値か確認する
   * @param s:any
   * @return hhmm、hh:mmの場合はtrue、違う場合はfalse
   */
  const IsTimeNumber = (s: any) => {
    if (s === undefined || s === null) {
      return false
    }
    const inputData = s.replaceAll(":", "")
    const inputNumber = parseInt(inputData)
    // 文字列の場合は入力キャンセル
    // .や-や0x、0oもキャンセル
    if (
      inputNumber === null ||
      isNaN(inputNumber) ||
      (!s.match(/:/) && s.match(/[^0-9]+/))
    ) {
      return false
    }
    // ２ケタ以下、５ケタ以上の場合は入力キャンセル
    if (4 < inputData.length || inputData.length < 3) {
      return false
    }
    // 数値に変換し、下2桁を分、上2桁を時間とする
    const h = Math.floor(inputNumber / 100)
    const m = inputNumber % 100
    // 時間が23より大きい場合は入力キャンセル
    if (23 < h) {
      return false
    }
    if (59 < m) {
      return false
    }
    return true
  }

  // グリッド初期化時イベントハンドラ
  const digiTachoGridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.refresh()
  }
  // グリッド初期化時イベントハンドラ
  const summaryGridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    // 追加行のみ初期化時に設定
    var extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)
    // ヘッダの設定
    grid.formatItem.addHandler(summaryFormatItem)
    grid.refresh()
  }

  // グリッド初期化時イベントハンドラ
  const dakokuGridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    const cellBinding = e.getColumn().binding
    const targetRow = e.getRow()
    const dataItem: T勤怠リスト = targetRow.dataItem
    if (!ref明細フォーマットフラグ.current) {
      var columnHeaders = f.columnHeaders

      columnHeaders.columns.forEach((c, index) => {
        switch (c.binding) {
          case "勤務日":
          case "曜日":
            columnHeaders.setCellData(0, index, "日付")
            break
          case "勤怠区分コード":
          case "出勤時刻":
          case "退勤時刻":
            columnHeaders.setCellData(0, index, "タイムカード")
            break
          case "勤務記号区分コード":
          case "深夜記号区分コード":
          case "休日出勤":
          case "祝日出勤":
          case "有休":
          case "特休":
            columnHeaders.setCellData(0, index, "勤務記号")
            break
          case "労務警告":
            columnHeaders.setCellData(0, index, "労務警告")
            break
          case "安全会議":
            columnHeaders.setCellData(0, index, "安全会議")
            break
          case "運行外業務記号区分コード":
            columnHeaders.setCellData(0, index, "運行外業務")
            break
          case "備考":
            columnHeaders.setCellData(0, index, "備考")
            break
          case "日別勤怠ID":
            columnHeaders.setCellData(0, index, "削除")
            break
          default:
            columnHeaders.setCellData(0, index, "")
            break
        }
        c.allowMerging = true
        c.align = "center"
      })
    }
    if (e.panel === f.cells) {
      switch (cellBinding as keyof T勤怠リスト) {
        case "出勤時刻":
        case "退勤時刻":
          if (
            出退勤時刻不正List.current != null &&
            出退勤時刻不正List.current.length > 0
          ) {
            const is不正Data = 出退勤時刻不正List.current.find(
              (d) => d === dataItem.row_id
            )
              ? true
              : false
            wjCore.toggleClass(e.cell, "data-warning", is不正Data)
          }
          break
        case "勤怠区分コード":
          if (
            勤怠区分不正List.current != null &&
            勤怠区分不正List.current.length > 0
          ) {
            const is不正Data = 勤怠区分不正List.current.includes(
              dataItem.row_id
            )
            wjCore.toggleClass(e.cell, "data-warning", is不正Data)
          }
          break
        case "運行外業務記号区分コード":
          if (
            運行外区分不正List.current != null &&
            運行外区分不正List.current.length > 0
          ) {
            const is不正Data = 運行外区分不正List.current.includes(
              dataItem.row_id
            )
            wjCore.toggleClass(e.cell, "data-warning", is不正Data)
          }
          break
      }
    }

    if (e.panel === f.cells) {
    }

    ref明細フォーマットフラグ.current = true
  }

  /**
   * グリッドのフォーマット
   */
  const summaryFormatItem = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.FormatItemEventArgs
  ) => {
    if (!ref明細フォーマットフラグ.current) {
      var columnHeaders = f.columnHeaders
      columnHeaders.columns.forEach((c, index) => {
        switch (c.binding) {
          case "出勤数":
          case "深夜数":
          case "休出数":
          case "祝出数":
          case "有休数":
          case "特休数":
            columnHeaders.setCellData(0, index, "勤怠日数")
            break
          case "年度開始有休日数":
          case "有休取得数":
          case "有休残数":
            columnHeaders.setCellData(0, index, "有休日数")
            break
          case "所定時間":
            columnHeaders.setCellData(0, index, "所定時間")
            break
        }
        c.allowMerging = true
        c.align = "center"
      })
    }
  }

  /**
   * 行挿入
   */
  const addNewRow = () => {
    if (flexGrid) {
      if (flexGrid.selection) {
        const rowIndex = flexGrid.selection.row
        const selectedRow: T勤怠リスト = flexGrid.rows[rowIndex].dataItem
        const newItem: T勤怠リスト = {
          勤務日: selectedRow.勤務日,
          row_id: Symbol(),
          複数行フラグ: 2,
        }
        flexGrid.collectionView.sourceCollection.splice(
          rowIndex + 1,
          0,
          newItem
        )

        flexGrid.collectionView.refresh()
      }
    }
  }
  const deleteNewRow = () => {
    if (deleteRowIndex) {
      gridData.data.removeAt(deleteRowIndex)
      flexGrid?.collectionView.refresh()
    }
    setIsDeleteNewRowConfirmModalShow(false)
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    clearError()
    let messages: string[] = []
    let isError = false
    // エラーチェック
    const 出退勤Valid = 出退勤Validate()
    isError = 出退勤Valid.hasError === true ? true : isError
    messages.push(...出退勤Valid.messages)
    if (isError) {
      dispatch(setWarningAlerts(messages))
      flexGrid?.refresh()
      return
    }

    setIsConfirmModalShow(true)
  }

  /**
   * エラークリア
   */
  const clearError = () => {
    dispatch(clearAlert())
    出退勤時刻不正List.current.splice(0)
    勤怠区分不正List.current.splice(0)
    運行外区分不正List.current.splice(0)
  }

  /**
   * 出退勤の入力チェック
   */
  const 出退勤Validate = () => {
    let 出退勤エラーチェック = false
    let 勤怠区分エラーチェック = false
    let 運行外区分エラーチェック = false
    let エラーメッセージList: string[] = []
    const gData: T勤怠リスト[] = gridData.data.items
    gData.forEach((d) => {
      const 出勤時刻 = dayjs(dayjs(d.勤務日).format("YYYY/MM/DD ") + d.出勤時刻)
      const 退勤時刻 = dayjs(dayjs(d.勤務日).format("YYYY/MM/DD ") + d.退勤時刻)
      // 出退勤時刻不正チェック
      if (d.出勤時刻 && d.退勤時刻 && 出勤時刻 >= 退勤時刻) {
        if (!出退勤エラーチェック) {
          出退勤エラーチェック = true
          エラーメッセージList.push("出退勤時刻が不正です。")
        }
        出退勤時刻不正List.current.push(d.row_id)
      }

      // 勤怠区分不正チェック
      if (d.勤怠区分コード == null && (d.出勤時刻 || d.退勤時刻)) {
        if (!勤怠区分エラーチェック) {
          勤怠区分エラーチェック = true
          エラーメッセージList.push("勤怠区分が入力されていません。")
        }
        勤怠区分不正List.current.push(d.row_id)
      }

      // 運行外区分不正チェック
      if (
        d.運行外業務記号区分コード != null &&
        d.勤怠区分コード !== e勤怠区分.出勤
      ) {
        if (!運行外区分エラーチェック) {
          運行外区分エラーチェック = true
          エラーメッセージList.push(
            "出勤以外の勤怠区分には運行外業務を入力できません。"
          )
        }
        運行外区分不正List.current.push(d.row_id)
      }
    })
    return {
      hasError:
        出退勤エラーチェック ||
        勤怠区分エラーチェック ||
        運行外区分エラーチェック,
      messages: エラーメッセージList,
    }
  }

  /**
   * 登録・更新
   */
  const submit = async () => {
    try {
      const service = new SyukkinboService()
      let res: TApiResponse<boolean>

      res = await service.zyomuinPutList(getData())

      if (res) {
        isPrompt.current = false
        search(createSearchCondition())
        dispatch(setAlerts(res))
        showInfoToast(`出勤簿の更新が完了しました`)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 更新用データ取得
   */
  const getData = () => {
    const putList: TZikanSyuseiListDetailPutReq[] = []
    const gData: TKintai[] = gridData.data.items

    gData.forEach((r) => {
      const str出勤時刻 = dayjs(r.出勤時刻).isValid()
        ? dayjs(r.出勤時刻)
        : dayjs(dayjs(r.勤務日).format("YYYY/MM/DD ") + r.出勤時刻)
      const str退勤時刻 = dayjs(r.退勤時刻).isValid()
        ? dayjs(r.退勤時刻)
        : dayjs(dayjs(r.勤務日).format("YYYY/MM/DD ") + r.退勤時刻)
      let kintaiData: TZikanSyuseiListDetailPutReq = {
        日別勤怠ID: r.日別勤怠ID,
        勤務日: r.勤務日,
        勤怠区分コード: r.勤怠区分コード,
        // HH:mmの文字列からミリ秒に変換するため、一度出勤日+時刻を文字列連結して
        //「YYYY/MM/DD HH:mm」の形にしてから、diffを使って時刻のミリ秒を取得する
        // （勤務日は「YYYY/MM/DD 00:00」の値のため、出勤時刻を合わせた文字列のDiffを取れば
        // 該当時刻のミリ秒が取得できる
        出勤時刻: r.出勤時刻
          ? dayjs(
              dayjs(r.勤務日).format("YYYY/MM/DD ") +
                str出勤時刻.format("HH:mm")
            ).diff(dayjs(r.勤務日))
          : undefined,
        退勤時刻: r.退勤時刻
          ? dayjs(
              dayjs(r.勤務日).format("YYYY/MM/DD ") +
                str退勤時刻.format("HH:mm")
            ).diff(dayjs(r.勤務日))
          : undefined,
        運行外業務記号区分コード: r.運行外業務記号区分コード,
        備考: r.備考,
        休日フラグ: r.勤怠区分コード ? 0 : 1,
        更新日時: r.更新日時,
      }
      putList.push(kintaiData)
    })

    let putData: TZikanSyuseiListPutReq = {
      年月,
      部所: 部所コード ?? "",
      氏名: 氏名 ?? "",
      社員番号: 社員番号 ?? "",
      社員区分: 社員区分 ?? "",
      勤怠リスト: putList!,
    }
    return putData
  }

  /**
   * 削除
   */
  const deleteRow = async () => {
    try {
      const service = new SyukkinboService()
      let res: TApiResponse<boolean>
      if (deleteID) {
        res = await service.delete(deleteID.toString())
        if (res) {
          isPrompt.current = false
          showInfoToast(`削除が完了しました。`)
          search(createSearchCondition())
        }
      } else {
        dispatch(setWarningAlerts(["勤怠情報が登録されていません。"]))
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsDeleteRowConfirmModalShow(false)
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(31)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([]),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)
  const [digiTachoFlexGrid, setDigiTachoFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [digiTachoGridData, setDigiTachoGridData] = useState<{
    data: wjCore.CollectionView
  }>({
    data: createCollectionView([]),
  })

  // 集計用グリッド
  const [summaryCountFlexGrid, setSummaryCountFlexGrid] =
    useState<wjcGrid.FlexGrid>()
  const [summaryGridData, setSummaryGridData] = useState<{
    data: wjCore.CollectionView
  }>({
    data: createCollectionView([]),
  })
  // 打刻リスト用グリッド
  const [dakokuFlexGrid, setDakokuFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [dakokuPageSize, setDakokuPageSize] = useState<number>(100)
  const [dakokuGridData, setDakokuGridData] = useState<{
    data: wjCore.CollectionView
  }>({
    data: createCollectionView([]),
  })
  const [dakokuPageNumber] = useState<number>(0)

  const [digiTachoPageSize, setDigiTachoPageSize] = useState<number>(31)

  const [digiTachoPageNumber] = useState<number>(0)
  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中
  const [, setIsDigiTachoSearching] = useState(false) // 検索中

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  const [digiTachoGridInitialized, setDigiTachoGridInitialized] =
    useState<boolean>(false)
  const [summaryCountGridInitialized, setSummaryCountGridInitialized] =
    useState<boolean>(false)
  const [dakokuGridInitialized, setDakokuGridInitialized] =
    useState<boolean>(false)
  //#endregion

  //#region [state]

  const [部所コード, set部所コード] = useState<string>()
  const [部所名, set部所名] = useState<string>()
  const [氏名, set氏名] = useState<string>()
  const [社員番号, set社員番号] = useState<string>()
  const [社員区分, set社員区分] = useState<string>()

  const [勤怠区分ItemSource, set勤怠区分ItemSource] = useState<T区分マスタ[]>()
  const [holidayList] = useState<Array<{ 休日: string }>>([])

  const [勤怠区分DataMap, set勤怠区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  // エラーチェック用
  const 出退勤時刻不正List = useRef<Symbol[]>([])
  const 勤怠区分不正List = useRef<Symbol[]>([])
  const 運行外区分不正List = useRef<Symbol[]>([])

  const [isDeleteRowConfirmModalShow, setIsDeleteRowConfirmModalShow] =
    useState(false)
  const [isDeleteNewRowConfirmModalShow, setIsDeleteNewRowConfirmModalShow] =
    useState(false)
  const [deleteID, setDeleteID] = useState<number>()
  const [deleteRowIndex, setDeleteRowIndex] = useState<number>()
  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `乗務員出勤簿`
    // 初期表示生成のため画面ロック
    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      set勤怠区分ItemSource(区分マスタRes.data)
      set勤怠区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) =>
              d.分類コード === 区分分類コード.運行管理_勤怠.勤怠区分 &&
              d.数値1 === parseInt(e社員区分.乗務員)
          ),
          "区分コード",
          "名称1"
        )
      )
    })
    dispatch(画面ロック開始())
  }, [])

  useEffect(() => {
    if (gridInitialized) {
      // クエリパラメータで検索条件作成
      const querySearchCondition: TSyukkinboGetReq = {
        社員ID: parseInt(所属_社員ID),
        年月,
      }

      // リストア中フラグON
      setIsRestoreSearching(true)
      // 検索
      if (querySearchCondition != null) {
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      }
    }
  }, [gridInitialized])

  //#endregion

  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">乗務員出勤簿</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row className="justify-content-start">
          {/* 出勤簿 */}
          <Col className="d-flex">
            <Card className="min-w-40rem">
              <Card.Body>
                <Container fluid className="label-form">
                  {/* 年月 */}
                  <LabelFormRow
                    label="年月"
                    positionClassName="d-flex"
                    labelWidth={6}>
                    <TextInput
                      style={{ width: "6rem" }}
                      id="年月"
                      name="年月"
                      value={dayjs(年月).format("YYYY/MM")}
                      setValue={() => {}}
                      isReadOnly></TextInput>
                  </LabelFormRow>
                  {/* 部所 */}
                  <LabelFormRow
                    label="部所"
                    positionClassName="d-flex"
                    labelWidth={6}>
                    <TextInput
                      style={{ width: "20rem" }}
                      id="部所名"
                      name="部所名"
                      value={部所名}
                      setValue={() => {}}
                      isReadOnly></TextInput>
                  </LabelFormRow>
                  {/* 氏名 */}
                  <LabelFormRow
                    label="氏名"
                    positionClassName="d-flex"
                    labelWidth={6}>
                    <div className="d-flex">
                      <TextInput
                        style={{ width: "6rem" }}
                        id="社員番号"
                        name="社員番号"
                        value={社員番号}
                        setValue={() => {}}
                        isReadOnly></TextInput>
                      <TextInput
                        id="氏名"
                        name="氏名"
                        value={氏名}
                        setValue={() => {}}
                        isReadOnly></TextInput>
                    </div>
                  </LabelFormRow>
                </Container>
              </Card.Body>
            </Card>
            <Card className="ms-3 min-w-45rem">
              <Card.Body>
                <FlexGridOuter
                  flexGrid={summaryCountFlexGrid}
                  setFlexGrid={setSummaryCountFlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  gridData={summaryGridData}
                  setGridData={setSummaryGridData}
                  pageNumber={1}
                  gridId={summaryCountGridId}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={summaryCountGridInitialized}
                  setGridInitialized={setSummaryCountGridInitialized}
                  isShowGridHeader={false}
                  isShowGridFooter={false}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  style={{ maxHeight: "Auto" }}
                  gridInitializedHandler={summaryGridInitializedHandler}
                  isShowGridRowPickupButton={false}
                  gridProperties={{
                    stickyHeaders: false,
                  }}
                  hasFilter={false}>
                  <wjrGrid.FlexGridColumn
                    binding="出勤数"
                    width={65}
                    format="n2"
                    align="right"
                    isReadOnly={true}
                    cssClass={"read-only-cell text-end"}
                    header="勤務"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="深夜数"
                    width={65}
                    format="n2"
                    align="right"
                    isReadOnly={true}
                    cssClass={"read-only-cell text-end"}
                    header="深夜"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="休出数"
                    width={65}
                    format="n2"
                    align="right"
                    isReadOnly={true}
                    cssClass={"read-only-cell text-end"}
                    header="休出"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="祝出数"
                    width={65}
                    format="n2"
                    align="right"
                    isReadOnly={true}
                    cssClass={"read-only-cell text-end"}
                    header="祝出"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="特休数"
                    width={65}
                    format="n2"
                    align="right"
                    isReadOnly={true}
                    cssClass={"read-only-cell text-end"}
                    header="特休"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="有休数"
                    width={65}
                    format="n2"
                    align="right"
                    isReadOnly={true}
                    cssClass={"read-only-cell text-end"}
                    header="有休"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="年度開始有休日数"
                    width={70}
                    format="n2"
                    align="right"
                    isReadOnly={true}
                    cssClass={"read-only-cell text-end"}
                    header="年度開始"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="有休取得数"
                    width={70}
                    format="n2"
                    align="right"
                    isReadOnly={true}
                    cssClass={"read-only-cell text-end"}
                    header="年度取得"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="有休残数"
                    width={70}
                    format="n2"
                    align="right"
                    isReadOnly={true}
                    cssClass={"read-only-cell text-end"}
                    header="残数"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="所定時間"
                    width={70}
                    format="n1"
                    align="right"
                    isReadOnly={true}
                    cssClass={"read-only-cell text-end"}
                    header="所定時間"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={7}>
            {/* カレンダー部分 */}
            <Row>
              <Col>
                {/* 検索結果カード */}
                <Card>
                  <Spinner searching={isSearching}></Spinner>
                  <Card.Body>
                    <FlexGridOuter
                      flexGrid={flexGrid}
                      setFlexGrid={setFlexGrid}
                      gridConstantProperties={
                        CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                      }
                      gridData={gridData}
                      setGridData={setGridData}
                      pageNumber={pageNumber}
                      gridId={`${gridId}_1`}
                      isRestoreSearching={isRestoreSearching}
                      setIsRestoreSearching={setIsRestoreSearching}
                      gridInitialized={gridInitialized}
                      setGridInitialized={setGridInitialized}
                      isShowGridFooter={true}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      gridInitializedHandler={gridInitializedHandler}
                      isShowGridRowPickupButton={false}
                      style={{ maxHeight: "Auto" }}
                      hasFilter={false}
                      headerComponent={
                        <>
                          <Button
                            variant="waiting"
                            onClick={() => {
                              beforeSubmit()
                            }}>
                            更新
                          </Button>
                          <Button
                            type="button"
                            className="ms-4"
                            onClick={() => addNewRow()}>
                            <FontAwesomeIcon icon={faPlusSquare} />
                            選択行追加
                          </Button>
                          <Button
                            type="button"
                            variant="secondary"
                            className="ms-4"
                            disabled={history.length <= 1}
                            onClick={() => history.goBack()}>
                            一覧に戻る
                          </Button>
                        </>
                      }
                      gridProperties={{
                        headersVisibility: wjcGrid.HeadersVisibility.Column,
                        allowAddNew: false,
                        allowMerging: wjcGrid.AllowMerging.ColumnHeaders,
                        allowSorting: wjcGrid.AllowSorting.None,
                        allowDragging: wjcGrid.AllowDragging.None,
                        selectionMode: wjcGrid.SelectionMode.Cell,
                      }}>
                      <wjrGrid.FlexGridColumn
                        binding="勤務日"
                        width={40}
                        isReadOnly={true}
                        cssClass={"read-only-cell"}
                        header="日">
                        {/* TODO:buttonじゃなくてaタグで遷移させたい。別Tab対応も考慮。 */}
                        <wjrGrid.FlexGridCellTemplate
                          cellType="Cell"
                          template={(
                            context: TWijmoCellTemplateContext<TKintai>
                          ) => {
                            // 休日カレンダー判定
                            let holidayCssClass = ""
                            if (
                              dayjs(context.item.勤務日).format("dd") === "日"
                            ) {
                              holidayCssClass = "holiday-color"
                            }
                            // 休日マスタとの判定
                            if (holidayCssClass === "") {
                              holidayList.find((i) => {
                                if (
                                  dayjs(context.item.勤務日).format(
                                    "YYYYMMDD"
                                  ) === dayjs(i.休日).format("YYYYMMDD")
                                ) {
                                  holidayCssClass = "holiday-color"
                                }
                                return holidayCssClass
                              })
                            }
                            return (
                              <span className={`${holidayCssClass}`}>
                                {dayjs(context.item.勤務日).format("DD")}
                              </span>
                            )
                          }}
                        />
                      </wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="曜日"
                        isReadOnly={true}
                        cssClass={"read-only-cell"}
                        width={40}
                        header="曜日">
                        <wjrGrid.FlexGridCellTemplate
                          cellType="Cell"
                          template={(
                            context: TWijmoCellTemplateContext<TKintai>
                          ) => {
                            // 休日判定
                            let holidayCssClass = ""
                            if (
                              dayjs(context.item.勤務日).format("dd") === "日"
                            ) {
                              holidayCssClass = "holiday-color"
                            }
                            // 休日マスタとの判定
                            if (holidayCssClass === "") {
                              holidayList.find((i) => {
                                if (
                                  dayjs(context.item.勤務日).format(
                                    "YYYYMMDD"
                                  ) === dayjs(i.休日).format("YYYYMMDD")
                                ) {
                                  holidayCssClass = "holiday-color"
                                }
                                return holidayCssClass
                              })
                            }
                            return (
                              <span className={`${holidayCssClass}`}>
                                {dayjs(context.item.勤務日).format("ddd")}
                              </span>
                            )
                          }}
                        />
                      </wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="勤怠区分コード"
                        width={90}
                        dataMap={勤怠区分DataMap}
                        isRequired={false}
                        header="勤務"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="出勤時刻"
                        width={80}
                        isRequired={false}
                        header="出勤"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="退勤時刻"
                        isRequired={false}
                        width={80}
                        header="退勤"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="勤務記号区分コード"
                        isReadOnly={true}
                        cssClass={"read-only-cell"}
                        dataMap={勤怠記号DataMap}
                        width={40}
                        header="勤務"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="深夜記号区分コード"
                        isReadOnly={true}
                        cssClass={"read-only-cell"}
                        dataMap={勤怠記号DataMap}
                        width={40}
                        header="深夜"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="休日出勤"
                        isReadOnly={true}
                        dataMap={勤怠記号DataMap}
                        cssClass={"read-only-cell"}
                        width={40}
                        header="休出"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="祝日出勤"
                        isReadOnly={true}
                        dataMap={勤怠記号DataMap}
                        cssClass={"read-only-cell"}
                        width={40}
                        header="祝出"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="特休"
                        isReadOnly={true}
                        cssClass={"read-only-cell"}
                        width={40}
                        header="特休"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="有休"
                        isReadOnly={true}
                        cssClass={"read-only-cell"}
                        width={40}
                        header="有休"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="労務警告"
                        isReadOnly={true}
                        wordWrap={true}
                        cssClass={"read-only-cell"}
                        width={50}
                        header="労務警告"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="安全会議"
                        isReadOnly={true}
                        wordWrap={true}
                        cssClass={"read-only-cell"}
                        width={50}
                        header="安全会議"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="運行外業務記号区分コード"
                        width={60}
                        wordWrap={true}
                        isRequired={false}
                        dataMap={運行外勤怠記号DataMap}
                        header="運行外業務"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="備考"
                        cssClass="text-start"
                        width={200}
                        header="備考"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="日別勤怠ID"
                        isRequired={false}
                        isReadOnly={true}
                        width={80}
                        header="削除">
                        <wjrGrid.FlexGridCellTemplate
                          cellType="Cell"
                          template={(
                            context: TWijmoCellTemplateContext<T勤怠リスト>
                          ) => {
                            if (context.item.複数行フラグ === 1) {
                              return (
                                <Button
                                  type="button"
                                  variant="caution"
                                  className="btn btn-small btn-primary move-edit-page"
                                  onClick={(e) => {
                                    e.preventDefault()
                                    setDeleteID(context.item.日別勤怠ID)
                                    setIsDeleteRowConfirmModalShow(true)
                                  }}>
                                  削除
                                </Button>
                              )
                            } else if (context.item.複数行フラグ === 2) {
                              return (
                                <Button
                                  type="button"
                                  variant="caution"
                                  className="btn btn-small btn-primary move-edit-page"
                                  onClick={(e) => {
                                    e.preventDefault()
                                    setDeleteRowIndex(context.row.index)
                                    setIsDeleteNewRowConfirmModalShow(true)
                                  }}>
                                  削除
                                </Button>
                              )
                            } else {
                              return <></>
                            }
                          }}
                        />
                      </wjrGrid.FlexGridColumn>
                    </FlexGridOuter>
                    <>
                      <Button
                        className="mx-1"
                        variant="waiting"
                        onClick={() => {
                          beforeSubmit()
                        }}>
                        更新
                      </Button>
                      <Button
                        type="button"
                        variant="secondary"
                        className="ms-4"
                        onClick={() => history.goBack()}>
                        一覧に戻る
                      </Button>
                    </>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
          <Col xs={5}>
            <Row>
              <Col>
                {/* デジタコ情報 */}
                <Card style={{ maxHeight: "75rem" }}>
                  <Card.Header>デジタコ情報</Card.Header>
                  <Spinner searching={isSearching}></Spinner>
                  <Card.Body>
                    <FlexGridOuter
                      flexGrid={digiTachoFlexGrid}
                      setFlexGrid={setDigiTachoFlexGrid}
                      gridConstantProperties={
                        CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                      }
                      gridData={digiTachoGridData}
                      setGridData={setDigiTachoGridData}
                      pageNumber={digiTachoPageNumber}
                      gridId={`${gridId}_2`}
                      isRestoreSearching={isRestoreSearching}
                      setIsRestoreSearching={setIsRestoreSearching}
                      gridInitialized={digiTachoGridInitialized}
                      setGridInitialized={setDigiTachoGridInitialized}
                      isShowGridFooter={false}
                      pageSize={digiTachoPageSize}
                      setPageSize={setDigiTachoPageSize}
                      gridInitializedHandler={digiTachoGridInitializedHandler}
                      isShowGridRowPickupButton={false}
                      hasFilter={false}
                      gridProperties={{
                        allowSorting: wjcGrid.AllowSorting.None,
                        allowDragging: wjcGrid.AllowDragging.None,
                      }}>
                      <wjrGrid.FlexGridColumn
                        binding="出庫日"
                        cssClass="read-only-cell"
                        width={70}
                        align={"center"}
                        header="出庫日">
                        <wjrGrid.FlexGridCellTemplate
                          cellType="Cell"
                          template={(
                            context: TWijmoCellTemplateContext<TZyomuinSyukkinboDigitachoRes>
                          ) => {
                            let dt = ""
                            if (context.item.出庫日)
                              dt = dayjs(context.item.出庫日).format("MM/DD")
                            return <>{dt}</>
                          }}
                        />
                      </wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="str出庫時刻"
                        cssClass="read-only-cell"
                        width={80}
                        align={"center"}
                        header="出庫時刻"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="入庫日"
                        cssClass="read-only-cell"
                        width={70}
                        align={"center"}
                        header="入庫日">
                        <wjrGrid.FlexGridCellTemplate
                          cellType="Cell"
                          template={(
                            context: TWijmoCellTemplateContext<TZyomuinSyukkinboDigitachoRes>
                          ) => {
                            let dt = ""
                            if (context.item.入庫日)
                              dt = dayjs(context.item.入庫日).format("MM/DD")
                            return <>{dt}</>
                          }}
                        />
                      </wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="str入庫時刻"
                        cssClass="read-only-cell"
                        width={80}
                        align={"center"}
                        header="入庫時刻"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="str休憩時間"
                        cssClass="read-only-cell"
                        width={80}
                        align={"center"}
                        header="休憩時間"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="str休息時間"
                        cssClass="read-only-cell"
                        width={80}
                        align={"center"}
                        header="休息時間"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="車番"
                        cssClass="read-only-cell"
                        width={60}
                        align={"center"}
                        header="車番"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="走行距離"
                        cssClass="read-only-cell"
                        width={80}
                        header="走行距離"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="高速料"
                        cssClass="read-only-cell"
                        width={70}
                        header="高速料"></wjrGrid.FlexGridColumn>
                    </FlexGridOuter>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col>
                {/* タイムカード情報 */}
                <Card style={{ maxHeight: "75rem" }}>
                  <Card.Header>タイムカード情報</Card.Header>
                  <Spinner searching={isSearching}></Spinner>
                  <Card.Body>
                    <FlexGridOuter
                      flexGrid={dakokuFlexGrid}
                      setFlexGrid={setDakokuFlexGrid}
                      hasFilter={false}
                      gridConstantProperties={
                        CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                      }
                      gridData={dakokuGridData}
                      setGridData={setDakokuGridData}
                      pageNumber={dakokuPageNumber}
                      gridId={dakokuCountGridId}
                      isRestoreSearching={isRestoreSearching}
                      setIsRestoreSearching={setIsRestoreSearching}
                      gridInitialized={dakokuGridInitialized}
                      setGridInitialized={setDakokuGridInitialized}
                      isEnablePageSize={"hidden"}
                      isShowGridHeader={false}
                      isShowGridFooter={false}
                      pageSize={dakokuPageSize}
                      setPageSize={setDakokuPageSize}
                      gridInitializedHandler={dakokuGridInitializedHandler}
                      gridProperties={{
                        headersVisibility: wjcGrid.HeadersVisibility.Column,
                        isReadOnly: false,
                        stickyHeaders: false,
                      }}
                      isShowGridRowPickupButton={false}>
                      <wjrGrid.FlexGridColumn
                        binding="勤務日"
                        width={80}
                        isReadOnly={true}
                        cssClass={"read-only-cell"}
                        header="勤務日"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="出退勤区分名称1"
                        width={80}
                        align={"center"}
                        cssClass={"read-only-cell"}
                        isRequired={false}
                        header="出退勤区分"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="出勤時間"
                        width={90}
                        align={"center"}
                        cssClass={"read-only-cell"}
                        isReadOnly={true}
                        isRequired={false}
                        header="出勤時刻"
                        format={"t"}></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="退勤時間"
                        isRequired={false}
                        cssClass={"read-only-cell"}
                        isReadOnly={true}
                        width={90}
                        align={"center"}
                        header="退勤時刻"
                        format={"HH:mm"}></wjrGrid.FlexGridColumn>
                    </FlexGridOuter>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>

      <ConfirmModal
        isShow={isDeleteRowConfirmModalShow}
        hideHandler={setIsDeleteRowConfirmModalShow}
        submitHandler={deleteRow}>
        選択した行を削除しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isDeleteNewRowConfirmModalShow}
        hideHandler={setIsDeleteNewRowConfirmModalShow}
        submitHandler={deleteNewRow}>
        選択した行を削除しますか？
      </ConfirmModal>
    </>
  )
}

export default ZyomuinSyukkinbo
